export default "__VITE_ASSET__dYDrFwoM__"